import React, { useState } from 'react';

const today = () => new Date().toISOString().split('T')[0];

const AdminFinancialsPaymentModal = ({ type, orderIds, orders, onConfirm, onClose }) => {
  const [checkNumber, setCheckNumber] = useState('');
  const [paymentDate, setPaymentDate] = useState(today());
  const [error, setError] = useState('');

  const selected = orders.filter(o => orderIds.includes(o.order_id));
  const total = selected.reduce((sum, o) => {
    const record = type === 'ar' ? o.ar : o.ap;
    return sum + (record?.amount || 0);
  }, 0);

  const label = type === 'ar' ? 'Title Company' : 'Notary';

  const handleConfirm = () => {
    if (!checkNumber.trim()) {
      setError('Check number is required');
      return;
    }
    onConfirm(checkNumber.trim(), paymentDate);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-neutral-200 w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
          <h2 className="text-base font-semibold text-neutral-800">
            Record {label} Payment
          </h2>
          <button onClick={onClose} className="text-neutral-400 hover:text-neutral-600 text-xl leading-none">&times;</button>
        </div>

        <div className="px-6 py-4 space-y-4">
          {/* Order summary */}
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 space-y-1 max-h-40 overflow-y-auto">
            {selected.map(o => (
              <div key={o.order_id} className="flex justify-between text-sm">
                <span className="text-neutral-600">{o.file_number} — {type === 'ar' ? o.title_company : o.notary_name}</span>
                <span className="font-medium text-neutral-800">
                  ${(type === 'ar' ? o.ar_amount : o.ap_amount).toFixed(2)}
                </span>
              </div>
            ))}
            <div className="border-t border-neutral-200 pt-1 mt-1 flex justify-between text-sm font-semibold">
              <span>Total</span>
              <span>${total.toFixed(2)}</span>
            </div>
          </div>

          {/* Check number */}
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1">
              Check Number <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={checkNumber}
              onChange={e => { setCheckNumber(e.target.value); setError(''); }}
              placeholder="e.g. 4521"
              className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>

          {/* Payment date */}
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1">Payment Date</label>
            <input
              type="date"
              value={paymentDate}
              onChange={e => setPaymentDate(e.target.value)}
              className="w-full px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            />
          </div>

          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
        </div>

        <div className="flex justify-end gap-2 px-6 py-4 border-t border-neutral-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
          >
            Record Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminFinancialsPaymentModal;
